<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getLevel" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.gradeId" placeholder="级别" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.gradeName" :value="item.gradeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.authStatus" placeholder="认证状态" filterable clearable style="width: 200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.authentication)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.status" placeholder="考试状态" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.examStatus2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.isImport" placeholder="缴费方式" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.isImport)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.isRepeat" placeholder="是否重复报名" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.boolean)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="reset" type="default">重置</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="refundBatch()" type="primary" style="margin-right: 10px;">
          批量退费
        </el-button>
        <el-button size="medium" @click="$router.push({path:'./import',query:$route.query})" style="margin-left: 0px;">返回上一步</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="报考订单号"></el-table-column>
        <el-table-column prop="admissionTicketNo" label="准考证号"></el-table-column>
        <el-table-column prop="examineeName" label="姓名"></el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
<!--        <el-table-column prop="officeName" label="考级点"></el-table-column>-->
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号"></el-table-column>
        <el-table-column prop="tradeFee" label="考级费"></el-table-column>
        <el-table-column prop="authStatus" label="考生是否认证">
          <template slot-scope="scope">
            {{$enums.authentication[scope.row.authStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="authStatus" label="考试状态">
          <template slot-scope="scope">
            {{$enums.examStatus2[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="isRepeat" label="是否重复报名">
          <template slot-scope="scope">
            {{$enums.boolean[scope.row.isRepeat]}}
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="报名时间"></el-table-column>
        <el-table-column prop="isImport" label="缴费方式">
          <template slot-scope="scope">
            {{$enums.isImport[scope.row.isImport]}}
          </template>
        </el-table-column>
        <el-table-column prop="subject" label="考生报考科目" width="120px">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
                       @click="$router.push(`./exam-question-edit?batchId=${scope.row.batchId}&importLogId=${scope.row.importLogId}&examId=${scope.row.examId}`)">
              {{scope.row.isfillsubject?'编辑报考科目':'去填写'}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
                       @click="$router.push(`./exam-edit?batchId=${scope.row.batchId}&importLogId=${scope.row.importLogId}&examId=${scope.row.examId}`)">
              编辑考生报考信息
            </el-button>
            <!--            <el-button v-if="scope.row.isPayed" size="mini" type="text" style="color: #E91212;" @click="del(scope.row)">删除</el-button>-->
            <el-button v-if="scope.row.isPayed" size="mini" type="text" style="color: #E91212;" @click="refundBatch(scope.row)">申请退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%">
      <p>当前进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'list',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, logId: this.$route.query.importLogId, isPayed: 1 },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      specialtyList: [],
      gradeList: [],
      dialogVisible: false,
      percent: null
    }
  },
  async created () {
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async reset () {
      this.queryParam = JSON.parse(JSON.stringify(this.oldQueryParam))
      this.gradeList = []
      await this.getSpecialtyList()
    },
    async getLevel (event) {
      if (event) {
        this.queryParam.gradeId = ''
      }
      this.gradeList = await this.$HTTP.ApiSpecialty.getGradeList({ specialtyId: this.queryParam.specialtyId, status: 2 })
      await this.getPage()
    },
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      if (event) {
        this.queryParam.specialtyId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiExamImport.getPageExam(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async del (row) {
      try {
        let confirm = await this.$confirm('确定要删除该记录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiExamImport.delExamBatch([row.examId])
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async refundBatch (row) {
      try {
        if (row) {
          // if (Number(row.status) === 0 || Number(row.status) === 1) {
          let confirm = await this.$confirm('确定要申请退款吗？', '提示', { type: 'warning' })
          if (confirm === 'confirm') {
            let examIds = []
            examIds.push(row.examId)
            let param = {
              examIds: examIds,
              importLogId: this.$route.query.importLogId
            }
            await this.$HTTP.ApiTrade.refundExam(param)
            this.getTaskInfo('batchRefund' + param.importLogId)
            // this.$message({ type: 'success', message: '操作成功' })
            await this.getPage()
          }
          // }
          // else {
          //   throw new Error('考试已开始，无法申请退款')
          // }
        } else {
          if (!this.multipleSelection.length) {
            throw new Error('请选择要操作的记录')
          }
          let confirm = await this.$confirm('确定要申请退款吗？', '提示', { type: 'warning' })
          if (confirm === 'confirm') {
            let examIds = []
            if (this.multipleSelection.length > 0) {
              this.multipleSelection.map(item => {
                examIds.push(item.examId)
              })
            }
            let param = {
              examIds: examIds,
              importLogId: this.$route.query.importLogId
            }
            await this.$HTTP.ApiTrade.refundExam(param)
            this.getTaskInfo('batchRefund' + param.importLogId)
            await this.getPage()
            // this.$message({ type: 'success', message: '操作成功' })
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamImport.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          if (taskInfo) {
            if (taskInfo.status === 0 && taskInfo.status !== 2) {
              this.dialogVisible = true
            }
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              } else {
                this.$message({ type: 'success', message: '操作成功' })
              }
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    }
  }
}
</script>
